export const MODELS = {
  ISSUE: 'Issue',
  BLOCK: 'Block',
  PIECE: 'Piece',
  AUTHOR: 'Author',
  BOOK: 'Book',
  ABOUT: 'About',
  MENU_PAGE: 'MenuPage',
  CONTACT: 'Contact',
  USER: 'User',
};

export const API_REQUESTS = {
  [MODELS.ISSUE]: {
    getOne: 'getIssueWithPieces',
    getAll: 'getIssues',
    create: 'createIssue',
    update: 'updateIssue',
    delete: 'deleteIssue',
  },
  [MODELS.BLOCK]: {
    getOne: 'getBlock',
    getAll: 'getBlocks',
    create: 'createBlock',
    update: 'updateBlock',
    delete: 'deleteBlock',
  },
  [MODELS.PIECE]: {
    getOne: 'getPiece',
    getAll: 'getPieces',
    create: 'createPiece',
    update: 'updatePiece',
    delete: 'deletePiece',
  },
  [MODELS.AUTHOR]: {
    getOne: 'getAuthor',
    getAll: 'getAuthors',
    create: 'createAuthor',
    update: 'updateAuthor',
    delete: 'deleteAuthor',
  },
  [MODELS.USER]: {
    getOne: 'getUser',
    getAll: 'getUsers',
    create: 'createUser',
    update: 'updateUser',
    delete: 'deleteUser',
  },
  [MODELS.BOOK]: {
    getAll: 'getBooks',
    create: 'createBook',
    update: 'updateBook',
    delete: 'deleteBook',
  },

  [MODELS.ABOUT]: {
    getAll: 'getAbout',
    create: 'createAbout',
    update: 'updateAbout',
  },

  [MODELS.MENU_PAGE]: {
    getAll: 'getMenuPages',
    update: 'updateMenuPage',
  },

  [MODELS.CONTACT]: {
    getAll: 'getContacts',
    create: 'createContact',
    update: 'updateContact',
    delete: 'deleteContact',
  },
};